import { Pipe } from '@angular/core';
var InitialPipe = (function () {
    function InitialPipe() {
    }
    InitialPipe.prototype.transform = function (input, num) {
        if (num === void 0) { num = 0; }
        return Array.isArray(input)
            ? input.slice(0, input.length - num)
            : input;
    };
    return InitialPipe;
}());
export { InitialPipe };
InitialPipe.decorators = [
    { type: Pipe, args: [{ name: 'initial' },] },
];
/** @nocollapse */
InitialPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=initial.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/initial.js
// module id = 204
// module chunks = 4